<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    class="ggwiki-logo"
  >
    <!-- Right-side G (normal) -->
    <text x="32" y="36" font-family="Arial, sans-serif" font-size="32" font-weight="bold" fill="var(--color-primary, #3b82f6)" text-anchor="middle">G</text>
    <!-- Left-side G (rotated 180 degrees for symmetry) -->
    <text x="16" y="12" font-family="Arial, sans-serif" font-size="32" font-weight="bold" fill="var(--color-primary, #3b82f6)" text-anchor="middle" transform="rotate(180, 16, 12)">G</text>
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  size?: number
}>(), {
  size: 48,
})
</script>

<style scoped>
.ggwiki-logo {
  display: block;
  flex-shrink: 0;
}
</style>
